import React, { useEffect } from 'react';
import '../styles/toast.css';

export default function Toast({ message, onDismiss }) {
  useEffect(() => {
    const t = setTimeout(onDismiss, 2500);
    return () => clearTimeout(t);
  }, [onDismiss]);

  return <div className="toast">{message}</div>;
}
